import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMarginLeft12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMarginLeft12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#MarginLeft12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M3.5 3h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5M6 2H3.5A1.5 1.5 0 0 0 2 3.5v5A1.5 1.5 0 0 0 3.5 10h5A1.5 1.5 0 0 0 10 8.5v-5A1.5 1.5 0 0 0 8.5 2zM1 3.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="MarginLeft12">
                        <path fill="#fff" d="M12 0v12H0V0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconMarginLeft12);
